export default __webpack_public_path__ + "static/media/elevate-blk-banner-1.34f55c76.jpg";